import { AuxButton } from "@blk/aladdin-react-components-es";
import { AuxButtonTypeEnum } from "@blk/aladdin-web-components";
import { isEqual } from "lodash";
import React from "react";
import { batch, useDispatch, useSelector } from "react-redux";
import { ModalName } from "components/modal/types";
import { language } from "language/default";
import { setPMIsMode } from "store/grid-settings";
import { removeAllSelectedRow } from "store/grids";
import { openModal } from "store/modal";
export const InsBulkPMISelectionMenu = (props) => {
    const dispatch = useDispatch(), selectedRows = useSelector((state) => state.grids.state[props.stateId]?.selectedRows, isEqual) ?? [];
    return React.createElement("div", { className: "insFundsHeaderLeft" },
        React.createElement(AuxButton, { isDisabled: selectedRows.length === 0, onClick: () => {
                dispatch(openModal({ content: { id: "pmis",
                        modalName: ModalName.PublicMarketIndicesList,
                        parameters: { ids: selectedRows, type: props.entityType, widgetId: props.stateId } },
                    title: language.en.modal.publicMarketIndicesSelection.title,
                    type: "action" }));
            }, type: AuxButtonTypeEnum.SECONDARY, label: language.en.grid.publicMarketIndices.setPMIs }),
        React.createElement(AuxButton, { className: "insFundsHeaderLeftTertiaryButton", icon: "delete", type: AuxButtonTypeEnum.TERTIARY, onClick: () => batch(() => {
                dispatch(setPMIsMode(false));
                dispatch(removeAllSelectedRow(props.stateId));
            }), label: language.en.grid.publicMarketIndices.closeSettings }));
};
